<template>
	<div class="encart-la-formation">
		<span class="title">
			<span class="first-line">Trouvez LA</span>
			<span class="second-line">Formation faite pour vous</span>
		</span>
		<KookBtn
			class="--angle-right --bg-white --font-orange"
			texte="Je trouve ma formation"
			url="https://www.greta-cfa-paysdelaloire.fr/nos-formations/"
			:blank="true"
		/>
	</div>
</template>

<script>
import KookBtn from '@components/global/KookBtn';
/**
 * Composant permettant d'afficher l'encart "trouver la formation" de la sidebar
 *
 * @version 1.0.0
 */
export default {
	name: 'EncartLaFormation',
	props: {},
	data() {
		return {};
	},
	mounted() {},
	methods: {},
	components: {
		KookBtn,
	},
};
</script>

<style lang="scss" scoped>
@import '~@scss/style.scss';

.encart-la-formation {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	padding: 30px;
	color: white;
	border-radius: 15px;
	background-color: $secondaryColor;
	text-align: center;

	.title {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		line-height: 30px;
		padding: 0 15px;

		.first-line {
			font-size: 17px;
		}

		.second-line {
			font-size: 25px;
			font-weight: bold;
			font-style: italic;
		}
	}
	
	.kook-btn {
		margin-top: 25px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar/EncartLaFormation.vue